var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconStreetSign = function SvgIconStreetSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.275 9.88-2-2.5a1 1 0 0 0-.78-.38h-6V1a1 1 0 0 0-2 0v1h-6a1 1 0 0 0-.78.38l-2 2.5a1 1 0 0 0 0 1.24l2 2.5a1 1 0 0 0 .78.38h6v9h-2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-2v-4h6a1 1 0 0 0 .78-.38l2-2.5a1 1 0 0 0 0-1.24ZM9.495 7h-5.52l-1.2-1.5 1.2-1.5h5.52v3Zm7.52 5h-5.52V9h5.52l1.2 1.5-1.2 1.5Z",
    fill: "currentColor"
  })));
};
export default SvgIconStreetSign;